import React from "react";
import PropTypes from "prop-types";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const getDefaultRoute = (user) => {
  if (user?.role === "partner" && user?.partnerUniqueId) {
    return `/partner/${user.partnerUniqueId}`;
  }

  return "/admin/partners";
};

const PrivateRoute = ({ roles }) => {
  const { user, isAuthenticated, loading, hasRole } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Загрузка...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (roles?.length && !hasRole(roles)) {
    return <Navigate to={getDefaultRoute(user)} replace />;
  }

  return <Outlet />;
};

PrivateRoute.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.string),
};

PrivateRoute.defaultProps = {
  roles: [],
};

export default PrivateRoute;
